/**
 * @author [jpcapelo]
 * @email [jhonnathanp27@gmail.com]
 * @create date 2021-08-29
 * @modify date 2021-09-05
 * @desc [Obtiene el tama o aplica tema por defecto]
 */

import ReactPixel from 'react-facebook-pixel';
import ReactGA from "react-ga4";
import { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// useLocation,
import { useParams } from 'react-router';
import useQueryString from 'src/hooks/useQueryString';

// import { themeDefault } from './Theme'
import validator from 'validator';
import useThemeService from 'src/services/useThemeService';


export default function useCustomTheme(themeDefault) {
  //let { idCotizacion = '', ...res }: any = useParams<{ idCotizacion }>();
  // const location = useLocation();

  //let { canalComercial='', empAseguradora= ''} =res?.parametros && validator.isBase64(res?.parametros) && JSON.parse(window.atob(res?.parametros)) || {};
  // const idProducto = useSelector(state => state?.Cotizacion?.cotizacion?.producto?.id)
  const { id } = useQueryString();
  const { idCotizacion, aseguradora, canal, grupo, canalComercial, parametros = null, empBroker, empAplica } = useParams<{ idCotizacion: string, aseguradora: string, canal: string, grupo: string, canalComercial: string, parametros: string, empBroker: string, empAplica: string }>()
  console.log('idProducto', idCotizacion, aseguradora, canal, grupo, canalComercial, parametros, empBroker, empAplica );

  const [ligthTheme, setligthTheme] = useState(undefined);
  const [darkTheme, setdarkTheme] = useState(undefined);
  const [custonTheme, setCustonTheme] = useState(undefined);
  const [isLoading, setLoading] = useState(false);


  // configuration for facebook pixel
  const advancedMatching = {
    em: "testlibelulasoft@gmail.com",
    ct: 'string',
    country: 'string',
    db: 'string',
    fn: 'string',
    ge: 'string',
    ln: 'string',
    ph: 'string',
    st: 'string',
    zp: 'string',
  }; // optional, more info: https://developers.facebook.com/docs/facebook-pixel/advanced/advanced-matching
  const options = {
    autoConfig: true, // set pixel's autoConfig. More info: https://developers.facebook.com/docs/facebook-pixel/advanced/
    debug: true, // enable logs
  };
  // configuration for google analytics
  const gaOptions = {

  }



  const addLight = (color, amount) => {
    let cc = parseInt(color, 16) + amount;
    let c = (cc > 255) ? 255 : (cc);
    c = (c.toString(16).length > 1) ? c.toString(16) : `0${c.toString(16)}`;
    return c;
  }

  const lighten = (color = '', amount) => {
    color = color?.replace("#", '');
    color = (color?.indexOf("#") >= 0) ? color?.substring(1, color.length) : color;
    amount = ((255 * amount) / 100);
    amount = parseInt(amount)

    console.log("tema:", color, amount)

    return color = `#${addLight(color.substring(0, 2), amount)}${addLight(color.substring(2, 4), amount)}${addLight(color.substring(4, 6), amount)}`;
  }

  const subtractLight = (color, amount) => {
    color = color.replace("#", '');
    let cc = parseInt(color, 16) - amount;
    let c: any = (cc < 0) ? 0 : (cc);
    c = (c.toString(16).length > 1) ? c.toString(16) : `0${c.toString(16)}`;
    return c;
  }

  const darken = (color, amount) => {
    color = (color.indexOf("#") >= 0) ? color.substring(1, color.length) : color;
    amount = ((255 * amount) / 100);
    amount = parseInt(amount);
    return color = `#${subtractLight(color.substring(0, 2), amount)}${subtractLight(color.substring(2, 4), amount)}${subtractLight(color.substring(4, 6), amount)}`;
  }



  let parametrosUrl: any = {
    canalComercial: canalComercial,
    empresa: aseguradora,
  }
  if (idCotizacion && idCotizacion !== '') {
    parametrosUrl.idCotizacion = idCotizacion;
    console.log("NO HAY COTIZACION ID 222")
  } else if (id && id !== '') {
    console.log("NO HAY COTIZACION ID 22222")
    parametrosUrl.idCotizacion = id;
  } else if (parametros) {
    console.log("NO HAY COTIZACION ID")
    let body = validator.isBase64(parametros) && JSON.parse(window.atob(parametros));
    console.log("BODY ",body)
    parametrosUrl.canalComercial = body.canalComercial;
    parametrosUrl.empresa = body.empBroker
  }else if(empAplica && empBroker){
    parametrosUrl.canalComercial = empAplica;
    parametrosUrl.empresa = empBroker
  }
  console.log("NO HAY COTIZACION ID FIN ", parametrosUrl)
  const { data, isValidating, error } = useThemeService({ params: parametrosUrl })
  console.log({ data, isValidating, error })
  useEffect(() => {
    (!isValidating &&  getTheme())
  }, [data])

  const getTheme = () => {
   
    setLoading(true);
    if (data) {
      const { colores = {} } = data
      console.log("NO HAY COTIZACION ID LLAMAR tema fff",colores )
      // colores primarios
      themeDefault.colors.primary = colores?.canColorFondoPrimario ?? themeDefault.colors.primary;
      console.log("NO HAY COTIZACION ID LLAMAR tema fff  themeDefault.colors.primary", themeDefault.colors.primary )
      themeDefault.colors.letraPrimaria1 = colores?.canColorPrimarioLetra1 ?? themeDefault.colors.letraPrimaria1;
      themeDefault.colors.letraPrimaria2 = colores?.canColorPrimarioLetra2 ?? themeDefault.colors.letraPrimaria2;

      // colores segundarios
      themeDefault.colors.secondary = colores?.canColorFondoSecundario ?? themeDefault.colors.secondary;
      themeDefault.colors.letraSegundaria1 = colores?.canColorSecundarioLetra1 ?? themeDefault.colors.letraSegundaria1;
      themeDefault.colors.letraSegundaria2 = colores?.canColorSecundarioLetra2 ?? themeDefault.colors.letraSegundaria2;

      // colores ternario
      themeDefault.colors.ternario = colores?.canColorFondoTernario ?? themeDefault.colors.ternario;
      themeDefault.colors.letraTernario1 = colores?.canColorTernarioLetra1 ?? themeDefault.colors.letraTernario1;
      themeDefault.colors.letraTernario2 = colores?.canColorTernarioLetra2 ?? themeDefault.colors.letraTernario2;

      //  colores complemento
      themeDefault.colors.secondaryLight = lighten(colores?.canColorFondoSecundario, 10) ?? themeDefault.colors.secondaryLight;
      themeDefault.colors.primarySemiDark = colores?.canColorFondoPrimario ? darken(colores?.canColorFondoPrimario, 10) : themeDefault.colors.primarySemiDark;

      themeDefault.color = themeDefault.colors

      // canIdFacebook
      // canIdGoogle

      // inicializacion de google analytics y facebook pixel
      ReactPixel.init('370679938158447', advancedMatching, options);
      ReactGA.initialize([
        {
          trackingId: colores?.canIdGoogle,
          // gaOptions: { ...}, // optional
          // gtagOptions: { ...}, // optional
        },
        {
          trackingId: "your second GA measurement id",
        },
      ]);
    }

    if (error) {
      console.log("error tema", error)
      // inicializacion de google analytics y facebook pixel
      ReactPixel.init('370679938158447', advancedMatching, options);
      ReactGA.initialize([
        {
          trackingId: "G-HJ4VJ9BJHQ",
          // gaOptions: { ...}, // optional
          // gtagOptions: { ...}, // optional
        },
        {
          trackingId: "your second GA measurement id",
        },
      ]);
    }
    setLoading(false);
  };
  // useEffect(() => {
  //   ReactPixel.init('370679938158447', advancedMatching, options);
  // }, [])

  // useEffect(() => {
  //   getTheme();
  // }, [idCotizacion]);

  return { ligthTheme, darkTheme, getTheme, custonTheme: themeDefault, isLoading: isLoading };
}
